// 관리자 전용 업무/기능 배정 탭
// PermissionAssignment 컴포넌트의 isDelegate=false 버전으로 위임
import PermissionAssignment from './PermissionAssignment';

export default function WorkAssignment() {
  return <PermissionAssignment isDelegate={false} />;
}
